import { action, makeObservable } from 'mobx';
import { BetSlipState } from 'src/domains/sportsbook/betting/state/BetSlipState';
import { BetslipSingleId } from 'src/domains/sportsbook/betting/models/BetslipIdModels';

export class BetSlipSelectionState {
    private readonly legId: BetslipSingleId;
    private readonly betSlipState: BetSlipState;

    public constructor(legId: BetslipSingleId, betSlipState: BetSlipState) {
        makeObservable(this);
        this.legId = legId;
        this.betSlipState = betSlipState;
    }

    @action public handleRemove = (): void => {
        const { basicBetSlipState, betSlipSummaryState, quickBetState, selectedBonuses } = this.betSlipState;
        const { isVisibleQuickBet } = quickBetState;
        const { onCloseQuickBet, onHideKeyboard, focusedSelectionId } = basicBetSlipState;
        const { clearError } = betSlipSummaryState;
        const legModel = this.legId.getModel();

        if (isVisibleQuickBet) {
            onCloseQuickBet();
        }
        if (focusedSelectionId !== null && focusedSelectionId === this.legId) {
            onHideKeyboard();
        }
        legModel.removeLeg();

        selectedBonuses.delete(this.legId.id.rawId);

        clearError();
    };
}
